var map = {
	"./buffer": 1907,
	"./buffer.js": 1907,
	"./console": 1908,
	"./console.js": 1908,
	"./dns": 1909,
	"./dns.js": 1909,
	"./empty": 4,
	"./empty.js": 4,
	"./net": 1910,
	"./net.js": 1910,
	"./process": 1911,
	"./process.js": 1911,
	"./punycode": 1912,
	"./punycode.js": 1912,
	"./tls": 1913,
	"./tls.js": 1913,
	"./tty": 1914,
	"./tty.js": 1914
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	return map[req] || (function() { throw new Error("Cannot find module '" + req + "'.") }());
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 4187;



//////////////////
// WEBPACK FOOTER
// (webpack)/~/node-libs-browser/mock ^\.\/.*$
// module id = 4187
// module chunks = 0